// dependency-graph-ignore-file
import { type Database } from '@databases/model/database';

export function reorderEntries(
  ydb: Database,
  { entryIds, newIndex }: { entryIds: string[]; newIndex: number }
): void {
  ydb.mutate((db) => {
    db.reorderEntries(entryIds, newIndex);
  });
}
